import {withLocalization} from '@epic-core/localization';
import {connectToStores} from 'epic-alt-utils';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import React from 'react';

import PageJumbotron from '../../components/common/PageJumbotron';
import BingResultsList from '../../components/search/BingResultsList';
import SearchStore from '../../stores/SearchStore';

/**
 * SearchView.
 *
 * Rendered when the Route matches /search
 */
@connectToStores
class SearchView extends React.Component {
  static getStores() {
    return [SearchStore];
  }

  static getPropsFromStores() {
    return {
      searchStore: SearchStore.getState(),
    };
  }

  static propTypes = {
    location: PropTypes.object,
    searchStore: PropTypes.object,
  };

  render() {
    const {searchStore, theme, messages = {}} = this.props;
    const {location = {}} = this.props;
    const config = searchStore.config || {};
    const searchQuery = location && location.search ? queryString.parse(location.search) : '';
    // try to get both 'keyword' and 'q' params value for the sake of backward compatibility, 'keyword' takes higher priority
    const query = searchQuery.keyword || searchQuery.q || '';
    const offset = parseInt(searchQuery.offset, 10) || 0;
    const filter =
      searchQuery.filter && searchQuery.filter !== 'undefined' ? searchQuery.filter : '';

    return (
      <div className="search-ctr">
        <PageJumbotron sectionName="epic.common.search" />

        <div className="searchView">
          <div className="container">
            <BingResultsList
              enableCustomFilter={config.enableCustomFilter}
              searchFilters={config.searchFilters || []}
              messages={messages}
              theme={theme}
              searchStore={searchStore}
              query={query}
              offset={offset}
              filter={filter}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withLocalization(SearchView);
